module.exports = __webpack_public_path__ + "static/media/phone1.da44c6f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone1.png
// module id = 279
// module chunks = 0